module.exports = __webpack_public_path__ + "media/images/webinar-2-d24c43ca1771159fc203651faff3b673.png";